import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { CorreccionCurpPage } from './correccion-curp/correccion-curp.component';
import { UnificacionCurpPage } from './unificacion-curp/unificacion-curp.component';
import { CertificacionCurpPage } from './certificacion-curp/certificacion-curp.component';
import { CurpPage } from './curp/curp.component';

let moduleName = 'renapo';

export const renapo: Routes = [
  {
    path: `${moduleName}/curp`,
    component: CurpPage,
    title: 'RENAPO - CURP.',
    canActivate: [authGuard, hasPermissionsGuard(['renapo_curp_access'])],
  },
  {
    path: `${moduleName}/correccion-curp`,
    component: CorreccionCurpPage,
    title: 'RENAPO - Corrección CURP.',
    canActivate: [authGuard, hasPermissionsGuard(['renapo_correccion_curp_access'])],
  },
  {
    path: `${moduleName}/unificacion-curp`,
    component: UnificacionCurpPage,
    title: 'RENAPO - Unificación CURP.',
    canActivate: [authGuard, hasPermissionsGuard(['renapo_unificacion_curp_access'])],
  },
  {
    path: `${moduleName}/certificacion-curp`,
    component: CertificacionCurpPage,
    title: 'RENAPO - Certificación CURP.',
    canActivate: [authGuard, hasPermissionsGuard(['renapo_certificacion_curp_access'])],
  },
];
